import axios, { AxiosRequestConfig } from 'axios';

// Configuration de l'instance Axios
const api = axios.create({
  baseURL: 'https://groupe-2ms.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor pour injecter le token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');

  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// POST JSON
export const createResource = async (endpoint: string, data: any) => {
  return api.post(`/${endpoint}`, data);
};

export const url = 'https://groupe-2ms.com';

// POST avec fichier
export const createResourceWithFile = async (endpoint: string, data: FormData) => {
  return api.post(`/${endpoint}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};



// PUT (avec ou sans fichier)
export const updateResource = async (
  endpoint: string,
  id: number | string,
  data: any | FormData,
  isFileUpload = false
) => {
  return api.put(`/${endpoint}/${id}`, data, {
    headers: isFileUpload ? { 'Content-Type': 'multipart/form-data' } : {},
  });
};

// Télécharger un fichier
export const downloadFile = async (endpoint: string) => {
  return api.get(`/${endpoint}`, {
    responseType: 'blob',
  });
};

// GET avec params (search, filters, pagination, etc.)
export const getResources = async (
  endpoint: string,
  config?: AxiosRequestConfig
) => {
  return api.get(`/${endpoint}`, config);
};

// GET by ID
export const getResourceById = async (endpoint: string, id: number | string) => {
  return api.get(`/${endpoint}/${id}`);
};

// Vérification email
export const forVerifyEmail = async (
  endpoint: string,
  id: number | string,
  token: string
) => {
  return api.get(`/${endpoint}/${id}/${token}`);
};

// DELETE
export const deleteResource = async (endpoint: string, id: number | string) => {
  return api.delete(`/${endpoint}/${id}`);
};

// PATCH
export const patchResource = async (
  endpoint: string,
  data: any
) => {
  return api.patch(`/${endpoint}`, data);
};

